import {HttpInterceptorFn, HttpStatusCode} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {registerCustomHandledStatuses} from './http-errror-handling.registry';
import {GlobalErrorService} from '../services/global-error.service';
import {isHoomvipApiRequest} from './http-api-scope';

registerCustomHandledStatuses(HttpStatusCode.Unauthorized)

let handling401 = false;

export const unauthorizedInterceptor : HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const globalError = inject(GlobalErrorService);


  if (!isHoomvipApiRequest(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      const anyErr = err as any;
      const status = typeof anyErr?.status === 'number' ? anyErr.status : undefined;

      if (status === HttpStatusCode.Unauthorized) {
        globalError.markHandled(err);

        if (!handling401) {
          handling401 = true;

          auth.logout();

          router.navigateByUrl('/login', {replaceUrl: true}).finally(() => {
            handling401 = false;
          });
        }
      }

      return throwError(() => err);
    }),
  );
};
